import Vue from 'vue';
import BotAPI from 'src/api/chatbots';
import { BfSpinner, BfButton } from 'components/Butterfly';
const AddIntegration = Vue.extend({
    components: { BfSpinner, BfButton },
    data() {
        return {
            error: '',
            loading: true,
        };
    },
    computed: {
        type() {
            return this.$route.params.type;
        },
        code() {
            return this.$route.query.code;
        },
        site() {
            return this.$route.query.state;
        },
    },
    mounted() {
        this.verifyCode();
    },
    methods: {
        async verifyCode() {
            this.loading = true;
            this.error = '';
            try {
                const url = `https://${window.location.host}${window.location.pathname}`;
                await BotAPI.verifyCode(this.code, this.type, url, this.site);
            }
            catch (error) {
                if (error.bodyText?.includes('!DOCTYPE')) {
                    this.error = 'Something went wrong. Please try again.';
                }
                else {
                    this.error = error.bodyText;
                }
            }
            finally {
                this.loading = false;
            }
        },
        goHome() {
            this.$router.push({ name: 'home', params: { site: this.site } });
        }
    }
});
export default AddIntegration;
